import { render, staticRenderFns } from "./myLeave.vue?vue&type=template&id=233d875b&scoped=true&"
import script from "./myLeave.vue?vue&type=script&lang=js&"
export * from "./myLeave.vue?vue&type=script&lang=js&"
import style0 from "./myLeave.vue?vue&type=style&index=0&id=233d875b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233d875b",
  null
  
)

export default component.exports